// AI-823 React context carrying the live UseTarotTheaterResult so consumer
// components (OracleExistingChat, TarotReframeModal wiring inside
// OracleResponsiveLayout) can read theater state without prop-drilling.
//
// The context value is `null` before the provider mounts or when the v2 toggle
// is off — consumers should guard before calling any method on the value.
import { createContext, useContext } from 'react'
import type { UseTarotTheaterResult } from './useTarotTheater'

export const TarotTheaterContext = createContext<UseTarotTheaterResult | null>(null)

export const useTarotTheaterContext = (): UseTarotTheaterResult | null => (
  useContext(TarotTheaterContext)
)
